<template>
  <div id="single-store-map" class="map-area">
    <gmap-map
      :center="storeCoordinates"
      :zoom="15"
      style="width: 100%; height: 400px"
    >
      <gmap-marker v-if="storeCoordinates" :position="storeCoordinates">
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  props: {
    store: Object,
  },
  computed: {
    google: gmapApi,
    selectedLocation() {
      if (this.$store.getters.formStore) {
        return this.$store.getters.formStore["location-id"];
      }
      return false;
    },
    storeCoordinates() {
      if (this.store.address.coordinates !== undefined) {
        return {
          lat: parseFloat(this.store.address.coordinates.latitude),
          lng: parseFloat(this.store.address.coordinates.longitude),
        };
      }
      return false;
    },
  },
  data: () => {
    return {
      map_checked: false,
      center: { lat: 26.4, lng: -80.08 },
    };
  },
  created() {},
  methods: {},
};
</script>
<style>
#store-info-container .map-area {
  order: 2;
}
</style>
